export default __webpack_public_path__ + "static/media/unauthorized_y.2c10f17c.svg";